<template>
  <v-card>
    <v-toolbar
      color="transparent"
      flat
    >
      <v-toolbar-title>אירועים אחרונים</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider />
    <v-list>
      <v-list-tile v-if="!events.length">
        <v-list-tile-content>
          <v-list-tile-title>אין אירועים</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="event in events"
        :key="'e' + event._id"
        avatar
        @click="$router.push(`/events/${event._id}`)"
      >

        <v-list-tile-content>
          <v-list-tile-title>{{ event.title }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ format(event.startDate, 'DD/MM/YYYY') }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-chip class="white--text" :color="event.type ? event.type.color : 'grey'">{{ event.type ? event.type.title : 'לא ידוע' }}</v-chip>
        </v-list-tile-action>

      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
import { format } from "date-fns";
import { axiosInstance } from "@/api";

export default {
  data() {
    return {
      events: []
    };
  },
  methods: {
    format,
    fetchLatestEvents() {
      let params = {
        q: JSON.stringify({ translators: this.translatorId }),
        limit: 10,
        sort: "-startDate"
      };
      axiosInstance.get("/events", { params }).then(({ data }) => {
        this.events = data.results;
      });
    }
  },
  mounted() {
    this.fetchLatestEvents();
  },
  props: ["translatorId"]
};
</script>



// WEBPACK FOOTER //
// src/components/translators/translator/TranslatorEvents.vue